import styled from "@emotion/styled";
import  ContentCopyTwoTone  from "@mui/icons-material/ContentCopyTwoTone";
import { Accordion, AccordionDetails, AccordionSummary, Backdrop, Box, Tooltip, Typography } from "@mui/material";

export const Container = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#D7C21B",
    color: "white",
    scrollMarginTop:"50px",
}));

export const ProjectText = styled(Typography)(() => ({
    fontWeight: "bold",
    fontSize: "26px",
    textAlign: "center",
    marginBottom: "15px",
    color: "#8000a4"
}));

export const ProjectsContainer = styled(Box)(() => ({
    display: "flex",
    flexWrap: "wrap",
    rowGap: "19px",
    columnGap: "11px",
    margin:"0px 6px"
}));

export const ProjectAccordion = styled(Accordion)(() => ({
    height: "fit-content",
    borderRadius: "15px !important",
    backgroundColor: "#0070ff",
    color: "white",
    fontWeight:"bold",
    width:"100%",
    '&::before':{
        backgroundColor:"transparent"
    }
}));
export const ProjectSummary = styled(AccordionSummary)(() => ({
    fontSize:"17px",
    fontWeight:"bold",
    '&.MuiAccordionSummary-content': {
        flexGrow: 0,
    },
    '& svg':{
        color:"white"
    },
    '&.MuiAccordionSummary-expandIconWrapper':{
        color:"white"
    }
}));
export const ProjectDetails = styled(AccordionDetails)(() => ({
    display:"flex",
    flexDirection:"column"
}));

export const Description=styled(Typography)(()=>({
    marginBottom:"9px"
}));

export const LinkOptions=styled(Box)(()=>({
    display: "flex",
    gap: "16px",
    '&>svg':{
        cursor:"pointer",
        '&:active':{
            outline: "auto"
        }
    }
}));

export const QrBackDrop=styled(Backdrop)(()=>({
    zIndex:1111
}));

export const QrContainer=styled(Box)(()=>({
    backgroundColor:"white",
    padding:"11px"
}));
export const StyledTooltip=({className,...props})=>(
    <Tooltip {...props} classes={{tooltip:className}} />
);
export const CustomToolTip=styled(StyledTooltip)(()=>({
    '&.MuiTooltip-tooltip':{
        backgroundColor:"#EB00FF !important",
        '&>span::before':{
            backgroundColor:"#EB00FF !important",
        }
    },
}));

export const CopiedIcon=styled(ContentCopyTwoTone)(()=>({
    '&>path:nth-child(1)':{color:"#EB00FF"}
}));
